import { type FC } from "react";

import { Segmented } from "@styled/segmented";

// Under 1280: which pane shows, the assistant or what it reads.
export const AssistantPaneSwitch: FC<{
  other: "Letters" | "Pages";
  showingAssistant: boolean;
  onChange(showAssistant: boolean): void;
}> = ({ other, showingAssistant, onChange }) => (
  <Segmented
    items={[
      { value: "assistant", label: "Assistant" },
      { value: "other", label: other },
    ]}
    selectedValue={showingAssistant ? "assistant" : "other"}
    onChange={(value) => onChange(value === "assistant")}
  />
);
